import {BarekamIcon} from "../icon/barekam-icon";
import {
    AdditionalServiceContainer,
    AdditionalServiceContainerSelected,
    AdditionalServiceContainerSlimSelected,
    AdditionalServiceSlimContainer,
    CountContainer,
    NameContainer,
    ServiceTitleContainer
} from "./styled";
import BarekamText from "../text";
import BarekamButton, {AdditionalServiceButtons} from "../button";
import {OrderIcons} from "../icon/variants";
import Message from "../message";
import {MessageSections} from "../message/message";
import {ReactJSXElement} from "@emotion/react/types/jsx-namespace";
import {OrderModel} from "../../shared/models/order/order-item.model";
import {AdditionalServiceWarehouseCardContainer} from "../../../management-pages/additional-services/card/styled";

const AdditionalServiceCard = (props: AdditionalServiceProps) => {
    const {usage, mainMessage: mainMessageKey, secondaryMessage, secondaryIcon, selected, slim, onClick, count} = props;

    function getBody() {
        switch (usage) {
            case AdditionalServiceUsage.NEW_ORDER:
                return (
                    <>
                        <BarekamText variant={'m'} fontWeight={600} align={'center'}>
                            <Message messageKey={mainMessageKey} sectionId={MessageSections.ORDERS}/>
                        </BarekamText>

                        {secondaryMessage && <BarekamText variant={'s'} fontWeight={500} align={'center'} opaque>{secondaryMessage}</BarekamText>}
                        {secondaryIcon || <></>}

                        <BarekamButton type={AdditionalServiceButtons.CHOOSE} onClick={() => onClick()} selected={selected}>
                            {selected
                                ? <BarekamIcon variant={OrderIcons.success}/>
                                : <Message messageKey={'choose'} sectionId={MessageSections.ORDERS}/>
                            }
                        </BarekamButton>
                    </>
                )
            case AdditionalServiceUsage.EDIT_ORDER:
                if (slim) {
                    return (
                        <>
                            <NameContainer>
                                {secondaryIcon}
                            </NameContainer>

                            <NameContainer>
                                <BarekamText variant={'m'} fontWeight={600} align={'left'}>
                                    <Message messageKey={mainMessageKey} sectionId={MessageSections.ORDERS}/>
                                </BarekamText>

                                {secondaryMessage
                                    ? <BarekamText variant={'s'} fontWeight={500} align={'left'} opaque>{secondaryMessage}</BarekamText>
                                    : ''
                                }
                            </NameContainer>
                        </>
                    )
                } else {
                    return (
                        <>
                            <BarekamText variant={'m'} fontWeight={600} align={'center'}>
                                <Message messageKey={mainMessageKey} sectionId={MessageSections.ORDERS}/>
                            </BarekamText>

                            <NameContainer>
                                {secondaryIcon}
                            </NameContainer>

                            {secondaryMessage && <BarekamText variant={'s'} fontWeight={500} align={'center'} opaque>{secondaryMessage}</BarekamText>}
                        </>
                    )
                }
            case AdditionalServiceUsage.WAREHOUSE:
                return (
                    <>
                        <NameContainer>
                            {secondaryIcon}
                        </NameContainer>

                        <NameContainer>
                            <ServiceTitleContainer>
                                <BarekamText variant={'m'} fontWeight={600} align={'left'}>
                                    <Message messageKey={mainMessageKey} sectionId={MessageSections.ORDERS}/>
                                </BarekamText>
                                <CountContainer>
                                    <BarekamText variant={'m'} fontWeight={600} align={'left'}>
                                        {count}
                                    </BarekamText>
                                </CountContainer>
                            </ServiceTitleContainer>

                            {secondaryMessage
                                ? <BarekamText variant={'s'} fontWeight={500} align={'left'} opaque>{secondaryMessage}</BarekamText>
                                : ''
                            }
                        </NameContainer>
                    </>
                )
            default:
                return <></>
        }
    }

    if (usage === AdditionalServiceUsage.WAREHOUSE) {
        return (
            <AdditionalServiceWarehouseCardContainer>{getBody()}</AdditionalServiceWarehouseCardContainer>
        );
    } else if (slim) {
        return selected
            ? <AdditionalServiceContainerSlimSelected>{getBody()}</AdditionalServiceContainerSlimSelected>
            : <AdditionalServiceSlimContainer>{getBody()}</AdditionalServiceSlimContainer>
    } else {
        return selected
            ? <AdditionalServiceContainerSelected>{getBody()}</AdditionalServiceContainerSelected>
            : <AdditionalServiceContainer>{getBody()}</AdditionalServiceContainer>
    }

};

export default AdditionalServiceCard;

interface AdditionalServiceProps {
    usage: AdditionalServiceUsage,
    selected: boolean,
    count?: number,
    slim?: boolean,

    mainMessage: string,
    secondaryMessage?: string,
    secondaryIcon?: ReactJSXElement,

    order?: OrderModel,

    onClick: () => void;
}

export enum AdditionalServiceUsage {
    NEW_ORDER = 'new-order',
    EDIT_ORDER = 'edit-order',
    USER = 'user-order',
    WAREHOUSE = 'warehouse',
}
